import React, { useState } from "react";
import PhoneNumberInput from "../../components/form/phone-number";
import { Button, notification, Card } from "antd";
import DataProvider from "../../services";
import { NotificationType } from "../../types";
import { useNavigate } from "react-router-dom";
import { convertToInternationalFormat } from "../../utils";
import { useAppStore } from "../../store";
import img from "../../assets/images/nr1.jpg";

export default function ActiveWithYelloCare() {
  const navigate = useNavigate();
  const { activateData } = useAppStore();
  const [loading, setLoading] = useState<boolean>(false);
  const [yolloCareData, setYolloCareData] = useState<any>({
    msisdn: "",
    yelloCareCode: "",
    name: "",
  });
  const [api, contextHolder] = notification.useNotification();

  const handleChange = (key: string, value: string) => {
    setYolloCareData({ ...yolloCareData, [key]: value });
  };

  const openNotificationWithIcon = (
    type: NotificationType,
    title: string,
    message: string
  ) => {
    api[type]({
      message: title,
      description: message,
    });
  };

  const handleSubmit = async () => {
    if (!yolloCareData.msisdn) {
      openNotificationWithIcon("warning", "Warning", "Please fill all fields");
      return;
    }

    setLoading(true);
    try {
      const payload = {
        msisdn: convertToInternationalFormat(yolloCareData.msisdn),
        name: activateData?.name || yolloCareData.msisdn,
        yelloCareCode: convertToInternationalFormat(yolloCareData.msisdn),
      };

      await DataProvider.activateWithYelloCare(payload);
      openNotificationWithIcon("success", "Success", "Activated successfully");
      navigate("/main");

      // if (response.status === 200 || response.status === 201) {
      //   openNotificationWithIcon(
      //     "success",
      //     "Success",
      //     "Activated successfully"
      //   );
      //   navigate("/pick-plan");
      // } else {
      //   openNotificationWithIcon(
      //     "error",
      //     "Failed",
      //     "Failed to activate, Kindly check your yello care code."
      //   );
      // }
    } catch (error: any) {
      const errMsg: string =
        error.response && error.response.data && error.response.data.message
          ? error.response.data.message
          : error.message;
      openNotificationWithIcon(
        "error",
        "Failed",
        errMsg || "Failed to activate, Kindly check your yello care code."
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="w-full h-full">
      {/* MOBILE VIEW */}
      <div
        className="h-screen lg:hidden flex flex-col w-full bg-cover bg-center bg-[#1A94ECB5] bg-blend-overlay relative"
        style={{ backgroundImage: `url(${img})` }}
      >
        <div className="flex-1 overflow-y-auto px-4 py-6 flex items-center justify-center">
          <Card className="shadow-xl border-0 rounded-3xl bg-white/95 backdrop-blur-sm w-full max-w-md">
            <div className="mb-8">
              <h1 className="text-3xl font-bold text-gray-900 mb-2">
                MCare Subscription
              </h1>
              <p className="text-gray-600">
                Activate your MCare subscription with YelloCare
              </p>
            </div>
            <div className="space-y-6">
              <PhoneNumberInput
                required
                title="Phone Number"
                value={yolloCareData.msisdn}
                onChangeText={(value: string) => handleChange("msisdn", value)}
                placeholder="0240005678"
                notes="This number will be your mcare subscription number. It is advisable to use a number with MoMo."
              />
              <Button
                type="primary"
                size="large"
                className="bg-[#1A94EC] w-full h-12 text-white font-semibold rounded-lg shadow-md hover:shadow-lg transition-all"
                onClick={handleSubmit}
                disabled={loading}
                loading={loading}
              >
                {loading ? "Activating..." : "Activate Subscription"}
              </Button>
            </div>
          </Card>
        </div>
      </div>

      {/* DESKTOP VIEW */}
      <div className="h-screen w-full lg:flex hidden">
        {/* Left Side - Branding */}
        <div
          className="h-full w-[50%] bg-center relative flex flex-col justify-between p-8 bg-cover bg-[#1A94ECB5] bg-blend-overlay"
          style={{ backgroundImage: `url(${img})` }}
        >
          <div className="relative z-10 text-white">
            <h1 className="text-6xl font-bold mb-4 leading-tight">
              Activate Your Subscription
            </h1>
            <p className="text-2xl font-light opacity-90">
              Get started with YelloCare today
            </p>
          </div>
        </div>

        {/* Right Side - Form */}
        <div className="h-full w-[50%] flex items-center justify-center bg-gradient-to-br from-gray-50 via-white to-blue-50 p-12 overflow-y-auto">
          <div className="w-full max-w-lg">
            <Card className="shadow-2xl border-0 rounded-3xl p-10 bg-white/95 backdrop-blur-sm">
              <div className="mb-8">
                <h1 className="text-5xl font-bold text-gray-900 mb-3 leading-tight">
                  MCare Subscription
                </h1>
                <p className="text-gray-600 text-lg">
                  Activate your MCare subscription with YelloCare
                </p>
              </div>
              <div className="space-y-6">
                <PhoneNumberInput
                  required
                  title="Phone Number"
                  value={yolloCareData.msisdn}
                  onChangeText={(value: string) => handleChange("msisdn", value)}
                  placeholder="0240005678"
                  notes="This number will be your mcare subscription number. It is advisable to use a number with MoMo."
                />
                <Button
                  type="primary"
                  size="large"
                  className="bg-gradient-to-r from-[#1A94EC] to-[#0d7bc4] w-full h-14 text-white font-semibold rounded-xl shadow-lg hover:shadow-xl hover:from-[#0d7bc4] hover:to-[#1A94EC] transition-all text-base"
                  onClick={handleSubmit}
                  disabled={loading}
                  loading={loading}
                >
                  {loading ? "Activating..." : "Activate Subscription"}
                </Button>
              </div>
            </Card>
          </div>
        </div>
      </div>
      {contextHolder}
    </div>
  );
}
